module.exports = __webpack_public_path__ + "static/shipkoo-express-3-8ee3c9da0fe734603b8756bcfec90229.png";